import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'nozero'})
export class NoZeroPipe implements PipeTransform {

  transform(value: string) {
      return value == '0' || value == '0.0' || value == '0,0' ? '' : value;
  }
}